let IS_PAGINATION = window.eventSettings?.enablePagination ?? true;

let ALL_EVENTS = [];
let CURRENT_STATUS = 'all';
let CURRENT_GENDER = 'all';
let CURRENT_DATE_FROM = null;
let CURRENT_DATE_TO = null;
let CURRENT_SEARCH = '';
let CURRENT_STATE = 'all';
let CURRENT_PRIZE = 'all';
let CURRENT_SURFACE = 'all';
let CURRENT_ENVIRONMENT = 'all';
let CURRENT_PAGE = 1;

const PAGE_SIZE = 12;

document.addEventListener('click', () => {
  document.querySelectorAll('.select-dropdown, .surface-dropdown').forEach((d) => d.classList.remove('show'));
});

// Custom Select Handling
document.querySelectorAll('.custom-select').forEach((select) => {
  const btn = select.querySelector('.select-btn');
  const dropdown = select.querySelector('.select-dropdown');

  btn.addEventListener('click', (e) => {
    e.stopPropagation();
    document.querySelector('.surface-dropdown')?.classList.remove('show');
    document.querySelectorAll('.select-dropdown').forEach((d) => {
      if (d !== dropdown) d.classList.remove('show');
    });
    dropdown.classList.toggle('show');
  });

  dropdown.querySelectorAll('.select-item').forEach((item) => {
    item.addEventListener('click', (e) => {
      e.stopPropagation();
      dropdown.querySelectorAll('.select-item').forEach((i) => i.classList.remove('active'));
      item.classList.add('active');
      updateSelectButtonText(btn, item.innerText);
      select.dataset.value = item.dataset.value;
      dropdown.classList.remove('show');
      updateActiveFilterCount();
    });
  });
});

/* =========================================================
   SURFACE FILTER
  ========================================================= */
const surfaceBtn = document.querySelector('.surface-btn');
if (surfaceBtn && !surfaceBtn.querySelector('svg')) {
  surfaceBtn.innerHTML = `
    <span class="surface-text">All | All</span>
    <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none">
      <path d="M0.134474 4.15884C-0.0330075 4.33829 -0.0429962 4.60822 0.0986352 4.79832L0.158843 4.86553L7.65884 11.8655C7.82693 12.0224 8.07618 12.042 8.26457 11.9244L8.34116 11.8655L15.8412 4.86553C16.043 4.67711 16.0539 4.36072 15.8655 4.15884C15.698 3.9794 15.4294 3.95084 15.23 4.07904L15.1588 4.13447L7.999 10.815L0.841161 4.13447C0.661716 3.96699 0.391787 3.957 0.201687 4.09864L0.134474 4.15884Z" fill="black"/>
    </svg>
  `;
}

const surfaceDropdown = document.querySelector('.surface-dropdown');
const outdoor = document.getElementById('outdoor');
const indoor = document.getElementById('indoor');
const envAll = document.getElementById('env_all');

surfaceBtn.addEventListener('click', (e) => {
  e.stopPropagation();
  document.querySelectorAll('.select-dropdown').forEach(d => d.classList.remove('show'));
  surfaceDropdown.classList.toggle('show');
});

surfaceDropdown.addEventListener('click', (e) => e.stopPropagation());

function updateSurfaceButton() {
  let type = 'All';

  if (CURRENT_ENVIRONMENT === 'outdoor') type = 'Outdoor';
  if (CURRENT_ENVIRONMENT === 'indoor') type = 'Indoor';

  const surface =
    document.querySelector('.surface-item.active')?.innerText || 'All';

  const textEl = surfaceBtn.querySelector('.surface-text');
  if (textEl) {
    textEl.innerText = `${type} | ${surface}`;
  }
}

/* ===== ENVIRONMENT: Outdoor / Indoor ===== */
[envAll, outdoor, indoor].forEach(cb => {
  cb.addEventListener('click', () => {

    if (cb === envAll && envAll.checked) {
      outdoor.checked = false;
      indoor.checked = false;
      CURRENT_ENVIRONMENT = 'all';
    }

    if (cb === outdoor && outdoor.checked) {
      envAll.checked = false;
      indoor.checked = false;
      CURRENT_ENVIRONMENT = 'outdoor';
    }

    if (cb === indoor && indoor.checked) {
      envAll.checked = false;
      outdoor.checked = false;
      CURRENT_ENVIRONMENT = 'indoor';
    }

    if (!envAll.checked && !outdoor.checked && !indoor.checked) {
      envAll.checked = true;
      CURRENT_ENVIRONMENT = 'all';
    }

    updateSurfaceButton();
    applyFilters(true);
    surfaceDropdown.classList.remove('show');
  });
});

/* ===== SURFACE: Grass / Clay / Hardcourt ===== */
document.querySelectorAll('.surface-item').forEach(item => {
  item.addEventListener('click', () => {
    document.querySelectorAll('.surface-item')
      .forEach(i => i.classList.remove('active'));

    item.classList.add('active');
    CURRENT_SURFACE = item.dataset.value;

    updateSurfaceButton();
    surfaceDropdown.classList.remove('show');
    applyFilters(true);
  });
});

updateSurfaceButton();

// Date Picker
const clearBtn = document.getElementById('clear-date');
const datePicker = flatpickr('#date_range', {
  mode: 'range',
  dateFormat: 'm/d/Y',
  onChange(selectedDates) {
    if (selectedDates.length !== 2) {
      clearBtn.style.display = 'none';
      return;
    }
    clearBtn.style.display = 'block';
    CURRENT_DATE_FROM = formatDateMMDDYYYY(selectedDates[0]);
    CURRENT_DATE_TO = formatDateMMDDYYYY(selectedDates[1]);
    fetchInitialEvents(CURRENT_DATE_FROM, CURRENT_DATE_TO);
    scrollToTop();
  }
});

clearBtn.addEventListener('click', async () => {
  datePicker.clear();
  clearBtn.style.display = 'none';
  CURRENT_DATE_FROM = null;
  CURRENT_DATE_TO = null;
  await fetchInitialEvents();
  applyFilters(true);
});

// Search
const searchForm = document.querySelector('.search-form');
const searchInput = document.querySelector('.search-input');

searchForm.addEventListener('submit', (e) => {
  e.preventDefault();
  CURRENT_SEARCH = searchInput.value.trim().toLowerCase();
  applyFilters(true);
});

searchInput.addEventListener('input', () => {
  CURRENT_SEARCH = searchInput.value.trim().toLowerCase();
  applyFilters(true);
});

// Mobile Filter Popup
const popupBtn = document.getElementById('popup-modal');
const popup = document.getElementById('filterPopup');
const closePopup = document.getElementById('closeFilterPopup');
const viewBtn = document.getElementById('viewResultsBtn');
const filtersWrapper = document.getElementById('filtersWrapper');
const popupFilters = document.getElementById('popupFilters');
const originalParent = filtersWrapper.parentNode;
const originalNext = filtersWrapper.nextSibling;

popupBtn?.addEventListener('click', () => {
  popup.classList.add('show');
  document.body.style.overflow = 'hidden';
  popupFilters.innerHTML = '';
  popupFilters.appendChild(filtersWrapper);
  setTimeout(updateActiveFilterCount, 100);
});

function closePopupFilter() {
  popup.classList.remove('show');
  document.body.style.overflow = '';
  if (originalNext) {
    originalParent.insertBefore(filtersWrapper, originalNext);
  } else {
    originalParent.appendChild(filtersWrapper);
  }
}

closePopup?.addEventListener('click', closePopupFilter);
viewBtn?.addEventListener('click', closePopupFilter);

// Active Filter Count
function updateActiveFilterCount() {
  let count = 0;
  document.querySelectorAll('#filtersWrapper .custom-select').forEach((select) => {
    const col = select.closest('[class*="col-"]');
    if (!col || window.getComputedStyle(col).display === 'none') return;

    const value = select.dataset.value || select.querySelector('.select-btn')?.innerText?.trim();
    if (value && !value.toLowerCase().includes('all')) count++;
  });

  if (document.getElementById('date_range')?.value) count++;

  const surfaceCol = document.querySelector('#filtersWrapper .col-surface');
  if (surfaceCol && window.getComputedStyle(surfaceCol).display !== 'none') {
    const surfaceVal = document.querySelector('#filtersWrapper .surface-btn')?.innerText;
    if (surfaceVal && !surfaceVal.toLowerCase().includes('all')) count++;
  }

  document.getElementById('activeFilterCount').innerText = count;
  document.getElementById('popupActiveFilterCount').innerText = count;
}

document.addEventListener('click', updateActiveFilterCount);
document.addEventListener('change', updateActiveFilterCount);

document.addEventListener('DOMContentLoaded', () => {
  fetchInitialEvents();
});

// Fetch Events
async function fetchInitialEvents(from, to) {
  const start = from || getFirstDayOfCurrentMonth();
  const end = to || getEndOfNextYear();

  const API_URL = `https://api.utrsports.net/v2/search/events?tours=College Circuits&top=250&skip=0` +
                  `&range=eventSchedule.eventStartUtc>=${start}` +
                  `&range=eventSchedule.eventStartUtc<=${end}` +
                  `&sort=eventSchedule.eventStartUtc:asc`;

  console.log('College Circuits API:', API_URL);

  try {
    const res = await fetch(API_URL);
    const data = await res.json();

    ALL_EVENTS = (data.hits || []).map(({ id, source: src }) => ({
      id,
      name: src.name,
      start: src.eventSchedule?.eventStartUtc || null,
      end: src.eventSchedule?.eventEndUtc || null,
      startShort: src.eventSchedule?.eventStartShort || '',
      endShort: src.eventSchedule?.eventEndShort || '',
      startMonth: src.eventSchedule?.eventStartMonth || '',
      endMonth: src.eventSchedule?.eventEndMonth || '',
      startDate: src.eventSchedule?.eventStartDate || '',
      endDate: src.eventSchedule?.eventEndDate || '',
      startYear: src.eventSchedule?.eventStartYear || '',
      endYear: src.eventSchedule?.eventEndYear || '',
      city: src.eventLocations?.[0]?.cityName,
      stateName: src.eventLocations?.[0]?.stateName,
      prize: src.prizeMoney,
      surface: src.eventDivisions?.[0]?.surfaces?.[0]?.value,
      environment: src.eventDivisions?.[0]?.environments?.[0]?.value,
      status: src.eventState?.value,
      gender: src.gender,
    }));

    buildStateFilter(ALL_EVENTS);
    applyFilters(true);
  } catch (error) {
    console.error('Error fetching events:', error);
    ALL_EVENTS = [];
    applyFilters(true);
  }
}

// Build State Filter
function buildStateFilter(events) {
  const dropdown = document.querySelector('.custom-select[data-name="state"] .select-dropdown');
  if (!dropdown) return;

  dropdown.innerHTML = '<div class="select-item active" data-value="all">All</div>';

  const states = [...new Set(events.map(e => e.stateName).filter(Boolean))].sort((a, b) => a.localeCompare(b));

  states.forEach(state => {
    const item = document.createElement('div');
    item.className = 'select-item';
    item.dataset.value = state;
    item.innerText = state;
    dropdown.appendChild(item);
  });

  dropdown.querySelectorAll('.select-item').forEach(item => {
    item.addEventListener('click', () => {
      dropdown.querySelectorAll('.select-item').forEach(i => i.classList.remove('active'));
      item.classList.add('active');
      CURRENT_STATE = item.dataset.value;
      applyFilters(true);
      scrollToTop();
    });
  });
}

// Filter & Render
function applyFilters(resetPage = false) {
  if (resetPage) CURRENT_PAGE = 1;

  const tbody = document.getElementById('eventTableBody');
  const cardList = document.getElementById('eventCardList');

  tbody.innerHTML = '';
  cardList.innerHTML = '';

  let filtered = ALL_EVENTS.filter(e => {
    if (!e.start) return false;

    const startDate = new Date(e.start);

    if (CURRENT_STATUS !== 'all' && e.status !== CURRENT_STATUS) return false;

    if (CURRENT_GENDER !== 'all' && e.gender !== CURRENT_GENDER && e.gender !== 'Co-ed') return false;

    if (CURRENT_STATE !== 'all' && e.stateName !== CURRENT_STATE) return false;

    if (CURRENT_PRIZE !== 'all') {
      const prize = e.prize || 0;
      if (CURRENT_PRIZE === '0') {
        if (prize !== 0 && prize != null) return false;
      } else if (CURRENT_PRIZE === '5001+') {
        if (prize <= 5000) return false;
      } else {
        const [min, max] = CURRENT_PRIZE.split('-').map(Number);
        if (prize < min || prize > max) return false;
      }
    }

    if (CURRENT_ENVIRONMENT !== 'all') {
      if (!e.environment) return false;
      if (e.environment.toLowerCase() !== CURRENT_ENVIRONMENT) return false;
    }

    if (CURRENT_SURFACE !== 'all') {
      if (!e.surface) return false;
      if (!e.surface.toLowerCase().includes(CURRENT_SURFACE)) return false;
    }

    if (CURRENT_DATE_FROM && CURRENT_DATE_TO) {
      const from = new Date(CURRENT_DATE_FROM);
      const to = new Date(CURRENT_DATE_TO);
      if (startDate < from || startDate > to) return false;
    }

    if (CURRENT_SEARCH && !e.name?.toLowerCase().includes(CURRENT_SEARCH)) return false;

    return true;
  });

  const total = filtered.length;

  updateResultCount(total);
  document.getElementById('popupResultCount').innerText = `${total} Results`;

  if (!total) {
    tbody.innerHTML = `<tr><td colspan="6">No events found</td></tr>`;
    cardList.innerHTML = `<div class="no-events">No events found</div>`;
    renderPagination(0);
    return;
  }

  if (IS_PAGINATION) {
    const startIndex = (CURRENT_PAGE - 1) * PAGE_SIZE;
    const endIndex = startIndex + PAGE_SIZE;
    const paginated = filtered.slice(startIndex, endIndex);

    tbody.innerHTML = paginated.map(renderEventRow).join('');
    cardList.innerHTML = paginated.map(renderEventCard).join('');
    renderPagination(total);
  } else {
    tbody.innerHTML = filtered.map(renderEventRow).join('');
    cardList.innerHTML = filtered.map(renderEventCard).join('');
    renderPagination(0);
  }
}

// Sorting
const table = document.querySelector('.event-table tbody');

let nameAsc = true;
let dateAsc = true;
let cityAsc = true;
let prizeAsc = true;
let surfaceAsc = true;
let statusAsc = true;

document.getElementById('sortName').addEventListener('click', () => {
  const rows = [...table.rows];
  rows.sort((a, b) => {
    const A = a.cells[0].innerText.toLowerCase();
    const B = b.cells[0].innerText.toLowerCase();
    return nameAsc ? A.localeCompare(B) : B.localeCompare(A);
  });
  nameAsc = !nameAsc;
  table.append(...rows);
});

document.getElementById('sortDate').addEventListener('click', () => {
  const rows = [...table.rows];
  rows.sort((a, b) => {
    const A = a.cells[1].dataset.start;
    const B = b.cells[1].dataset.start;
    return dateAsc ? new Date(A) - new Date(B) : new Date(B) - new Date(A);
  });
  dateAsc = !dateAsc;
  table.append(...rows);
});

document.getElementById('sortCity').addEventListener('click', () => {
  const rows = [...table.rows];
  rows.sort((a, b) => {
    const A = a.cells[2].innerText.toLowerCase();
    const B = b.cells[2].innerText.toLowerCase();
    return cityAsc ? A.localeCompare(B) : B.localeCompare(A);
  });
  cityAsc = !cityAsc;
  table.append(...rows);
});

document.getElementById('sortPrize').addEventListener('click', () => {
  const rows = [...table.rows];
  rows.sort((a, b) => {
    const A = parseInt(a.cells[3].innerText.replace(/\D/g, '')) || 0;
    const B = parseInt(b.cells[3].innerText.replace(/\D/g, '')) || 0;
    return prizeAsc ? A - B : B - A;
  });
  prizeAsc = !prizeAsc;
  table.append(...rows);
});

document.getElementById('sortSurface').addEventListener('click', () => {
  const rows = [...table.rows];
  rows.sort((a, b) => {
    const A = (a.cells[4].dataset.surface || '').toLowerCase();
    const B = (b.cells[4].dataset.surface || '').toLowerCase();
    return surfaceAsc ? A.localeCompare(B) : B.localeCompare(A);
  });
  surfaceAsc = !surfaceAsc;
  table.append(...rows);
});

document.getElementById('sortStatus').addEventListener('click', () => {
  const rows = [...table.rows];
  rows.sort((a, b) => {
    const A = a.cells[5].innerText.toLowerCase();
    const B = b.cells[5].innerText.toLowerCase();
    return statusAsc ? A.localeCompare(B) : B.localeCompare(A);
  });
  statusAsc = !statusAsc;
  table.append(...rows);
});

// Filter Bindings
document.querySelectorAll('.custom-select[data-name="status"] .select-item').forEach(item => {
  item.addEventListener('click', () => {
    CURRENT_STATUS = item.dataset.value;
    updateSelectUI(item);
    applyFilters(true);
    scrollToTop();
  });
});

document.querySelectorAll('.custom-select[data-name="gender"] .select-item').forEach(item => {
  item.addEventListener('click', () => {
    CURRENT_GENDER = item.dataset.value;
    updateSelectUI(item);
    applyFilters(true);
    scrollToTop();
  });
});

document.querySelectorAll('.custom-select[data-name="prize"] .select-item').forEach(item => {
  item.addEventListener('click', () => {
    CURRENT_PRIZE = item.dataset.value;
    updateSelectUI(item);
    applyFilters(true);
    scrollToTop();
  });
});

document.querySelector('.custom-select[data-name="state"] .select-dropdown').addEventListener('click', function (e) {
  const item = e.target.closest('.select-item');
  if (!item) return;
  this.querySelectorAll('.select-item').forEach(i => i.classList.remove('active'));
  item.classList.add('active');
  CURRENT_STATE = item.dataset.value;
  updateSelectButtonText(this.parentElement.querySelector('.select-btn'), item.innerText);
  applyFilters(true);
  scrollToTop();
});

// Helper Functions
function updateSelectUI(item) {
  const select = item.closest('.custom-select');
  const btn = select.querySelector('.select-btn');
  select.querySelectorAll('.select-item').forEach(i => i.classList.remove('active'));
  item.classList.add('active');
  updateSelectButtonText(btn, item.innerText);
}

function updateSelectButtonText(btn, text) {
  if (!btn) return;
  if (btn.firstChild && btn.firstChild.nodeType === Node.TEXT_NODE) {
    btn.firstChild.nodeValue = text + ' ';
  } else {
    btn.insertBefore(document.createTextNode(text + ' '), btn.firstChild);
  }
}

function updateResultCount(count) {
  const el = document.getElementById('resultCount');
  if (el) el.innerText = `${count} Result${count !== 1 ? 's' : ''}`;
}

function formatPrize(prize) {
  return prize ? `$${prize.toLocaleString()}` : '-';
}

function formatSurface(env, surface) {
  if (!env && !surface) return '-';

  let formattedSurface = surface;

  if (surface && surface.toLowerCase() === 'hardcourt') {
    formattedSurface = 'Hard';
  }

  if (env && formattedSurface) return `${env} | ${formattedSurface}`;
  return env || formattedSurface;
}

function formatEventDateRangeM(event) {
  const startUtc = event?.start;
  const endUtc = event?.end;
  if (!startUtc || !endUtc) return '-';

  const start = new Date(startUtc);
  const end = new Date(endUtc);
  const fmt = { month: 'short', day: 'numeric' };
  const withYear = d => `${d.toLocaleDateString('en-US', fmt)}, '${String(d.getFullYear()).slice(-2)}`;

  if (start.getFullYear() === end.getFullYear()) {
    return `${start.toLocaleDateString('en-US', fmt)} – ${withYear(end)}`;
  }
  return `${withYear(start)} – ${withYear(end)}`;
}

function getFirstDayOfCurrentMonth() {
  const d = new Date();
  d.setDate(1);
  return formatDateMMDDYYYY(d);
}

function getEndOfNextYear() {
  const now = new Date();
  const d = new Date(now.getFullYear() + 1, 11, 31);
  return formatDateMMDDYYYY(d);
}

function formatDateMMDDYYYY(date) {
  const m = String(date.getMonth() + 1).padStart(2, '0');
  const d = String(date.getDate()).padStart(2, '0');
  const y = date.getFullYear();
  return `${m}/${d}/${y}`;
}

function renderStatusBadge(statusValue) {
  const STATUS_MAP = {
    open_registration: { text: 'Register', class: 'badge-open' },
    registration_closed: { text: 'Upcoming', class: 'badge-upcoming' },
    in_progress: { text: 'Live', class: 'badge-live' },
    completed: { text: 'Complete', class: 'badge-complete' }
  };
  const status = STATUS_MAP[statusValue];
  if (!status) return `<span class="badge">${statusValue || '-'}</span>`;
  return `<span class="badge ${status.class}">${status.text}</span>`;
}

function renderEventRow(event) {
  return `
    <tr>
      <td><a href="https://app.utrsports.net/events/${event.id}" target="_blank" class="event-title">${event.name || '-'}</a></td>
      <td data-start="${event.start}">${formatEventDateRangeM(event)}</td>
      <td>${event.city ? event.city + ', ' + (event.stateName || '') : (event.stateName || '')}</td>
      <td>${formatPrize(event.prize)}</td>
      <td style="text-transform: capitalize; display:none;" data-surface="${event.surface || ''}">${formatSurface(event.environment, event.surface)}</td>
      <td><a href="https://app.utrsports.net/events/${event.id}" target="_blank">${renderStatusBadge(event.status)}</a></td>
    </tr>
  `;
}

function renderEventCard(event) {
  const location = event.city
    ? `${event.city}, ${event.stateName || ''}`
    : (event.stateName || '-');

  const surfaceDisplay = formatSurface(event.environment, event.surface);

  return `
    <div class="event-card">
      <a class="link-to-event" href="https://app.utrsports.net/events/${event.id}">
        <div class="event-card-title">${event.name || '-'}</div>
        <div class="event-card-date">${formatEventDateRangeM(event)}</div>
        <div class="event-card-row">
          <span>City/State:</span>
          <strong>${location}</strong>
        </div>
        <div class="event-card-bottom">
          <div class="event-card-row" style="display:none;">
            <span>Surface:</span>
            <strong>${surfaceDisplay}</strong>
          </div>
          <div class="event-card-row">
            <span>Prize:</span>
            <strong>${formatPrize(event.prize)}</strong>
          </div>
          <div class="event-card-status">
            ${renderStatusBadge(event.status)}
          </div>
        </div>
      </a>
    </div>
  `;
}

function renderPagination(total) {
  const el = document.getElementById('pagination');
  if (!el) return;

  const totalPages = Math.ceil(total / PAGE_SIZE);

  if (totalPages <= 1) {
    el.innerHTML = '';
    return;
  }

  const WINDOW = 5;

  let start = Math.max(1, CURRENT_PAGE - Math.floor(WINDOW / 2));
  let end = start + WINDOW - 1;

  if (end > totalPages) {
    end = totalPages;
    start = Math.max(1, end - WINDOW + 1);
  }

  let html = '';

  html += `
    <button class="page-btn prev ${CURRENT_PAGE === 1 ? 'disabled' : ''}" ${CURRENT_PAGE === 1 ? 'disabled' : ''}>
      Prev
    </button>
  `;

  if (start > 1) {
    html += `<button class="page-btn" data-page="1">1</button>`;
    if (start > 2) html += `<span class="page-dots">...</span>`;
  }

  for (let i = start; i <= end; i++) {
    html += `
      <button class="page-btn ${i === CURRENT_PAGE ? 'active' : ''}" data-page="${i}">
        ${i}
      </button>
    `;
  }

  if (end < totalPages) {
    if (end < totalPages - 1) html += `<span class="page-dots">...</span>`;
    html += `<button class="page-btn" data-page="${totalPages}">${totalPages}</button>`;
  }

  html += `
    <button class="page-btn next ${CURRENT_PAGE === totalPages ? 'disabled' : ''}" ${CURRENT_PAGE === totalPages ? 'disabled' : ''}>
      Next
    </button>
  `;

  el.innerHTML = html;

  const eventSection = document.querySelector('.event-table');

  el.querySelectorAll('.page-btn[data-page]').forEach(btn => {
    btn.onclick = () => {
      CURRENT_PAGE = Number(btn.dataset.page);
      applyFilters(false);
      eventSection?.scrollIntoView({ behavior: 'smooth', block: 'start' });
    };
  });

  el.querySelector('.prev')?.addEventListener('click', () => {
    if (CURRENT_PAGE > 1) {
      CURRENT_PAGE--;
      applyFilters(false);
      eventSection?.scrollIntoView({ behavior: 'smooth', block: 'start' });
    }
  });

  el.querySelector('.next')?.addEventListener('click', () => {
    if (CURRENT_PAGE < totalPages) {
      CURRENT_PAGE++;
      applyFilters(false);
      eventSection?.scrollIntoView({ behavior: 'smooth', block: 'start' });
    }
  });
}

// Reset Filters
document.querySelectorAll('.resetFilters').forEach(btn => {
  btn.addEventListener('click', async () => {
    CURRENT_STATUS = 'all';
    CURRENT_GENDER = 'all';
    CURRENT_STATE = 'all';
    CURRENT_PRIZE = 'all';
    CURRENT_SURFACE = 'all';
    CURRENT_ENVIRONMENT = 'all';
    CURRENT_SEARCH = '';
    CURRENT_DATE_FROM = null;
    CURRENT_DATE_TO = null;
    CURRENT_PAGE = 1;

    document.querySelectorAll('.custom-select').forEach(select => {
      const allItem = select.querySelector('.select-item[data-value="all"]');
      if (allItem) {
        select.querySelectorAll('.select-item').forEach(i => i.classList.remove('active'));
        allItem.classList.add('active');
        updateSelectButtonText(select.querySelector('.select-btn'), 'All');
      }
    });

    document.getElementById('env_all').checked = true;
    document.getElementById('outdoor').checked = false;
    document.getElementById('indoor').checked = false;
    document.querySelectorAll('.surface-item').forEach(i => i.classList.remove('active'));
    document.querySelector('.surface-item[data-value="all"]')?.classList.add('active');

    updateSurfaceButton();

    if (datePicker) datePicker.clear();
    document.getElementById('clear-date').style.display = 'none';
    searchInput.value = '';

    await fetchInitialEvents();
    updateActiveFilterCount();
  });
});

function scrollToTop() {
  if (!window.blockscrollsection) {
    const tableTop = document.querySelector('.ptt-calendar-table')?.offsetTop || 0;
    window.scrollTo({ top: tableTop - 100, behavior: 'smooth' });
  }
}